export var Link = {
  baseStyle: {
    color: 'primary.400',
    textStyle: 'textlink-normal-medium',
    _active: {
      color: 'primary.700'
    }
  }
};
//# sourceMappingURL=Link.js.map